module.exports = __webpack_public_path__ + "media/images/bubble-img-service-intro-question-01-c8d70adfb8b438735b8ecb3c4e768e97.png";